/* import __COLOCATED_TEMPLATE__ from './class-group-vtyc-points-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class ClassGroupPenaltiesCardComponent extends Component 
{
	@service store;
	
	@tracked classGroup = null;
	
	@tracked selectedPtsTable = null;
	
	@tracked selectedRacePts = null;//pts destination
	@tracked selectedRacePtsName = null;
	
	pointsTable = [500,490,481,473,466,460,455,451,448,445,442,439,436,433,430,427,424,421,418,415,412,409,406,403,400,397,394,391,388,385,382,379,376,373,370,367,364,361,358,355,352,349,346,343,340,337,334,331,328,325];
	
	@action
	async selectClassGroup(event)
	{
		var classGroupId = event.target.value;
		
		if(classGroupId == '-')
		{
			this.classGroup = null;
		}
		else
		{
			this.classGroup = await this.store.findRecord('classGroup', classGroupId);
			this.calculateRacePoints();
		}
	}
	
	@action
	selectPtsTable(event)
	{
		var ptsTableName = event.target.value;
		
		if(ptsTableName == '-')
		{
			this.selectedPtsTable = null;
		}
		else
		{
			this.selectedPtsTable = ptsTableName;
		}
		this.calculateRacePoints();
	}
	
	@action
	selectRacePts(event)
	{
		var ptsCol = event.target.value;
		
		if(ptsCol == '-')
		{
			this.selectedRacePts = null;
			this.selectedRacePtsName = null;
		}
		else
		{
			this.selectedRacePts = ptsCol;
			this.selectedRacePtsName = ptsCol+"Name";
		}
	}
	
	@action
	async savePoints()
	{
		if(this.classGroup && this.selectedPtsTable && this.selectedRacePts)
		{
			var results = await this.classGroup.get('results');
			await this.args.event.hasMany('entries').reload();
			var entries = (await this.args.event.get('entries')).slice();
			for(var result of [...results])
			{
				for(var entry of entries)
				{
					if(entry.bib == result.bib)
					{
						entry.set(this.selectedRacePts,result.calculatedRacePoints);
						entry.save();
					}
				}
			}
		}
	}
	
	async calculateRacePoints()
	{
		if(this.classGroup && this.selectedPtsTable)
		{
			const results = await this.classGroup.get('results');
			for(const [index,result] of results.slice().entries())
			{
				if(result.status == "OK" && result.totalTimeInMilliseconds)
				{
					if(this.selectedPtsTable == "A")
					{
						result.set('calculatedRacePoints',this.pointsTable[index]+5);
					}
					else
					{
						result.set('calculatedRacePoints',this.pointsTable[index]);
					}
				}
			}
		}
	}
}